import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "form-select-multiple__selection" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "form-select-multiple__options"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_7 = ["id"]

import {FormOption} from "@/types/formOption";
import {Status, validateArray} from '@/validation'
import {requiredArray, RuleArray} from '@/validation/rules'
import {ref, watch} from "vue";
import {useI18n} from "vue3-i18n";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormMultiSelect',
  props: {
    name: {},
    modelValue: {},
    label: {},
    rules: {},
    options: {},
    noLabel: { type: Boolean },
    maxItems: {}
  },
  emits: ["onOptionChange", "validated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
  validateInput
})

// eslint-disable-next-line
const emit = __emit;

const {t} = useI18n();
const status = ref<Status>({valid: true});
const isRequired = !(props.rules != null && props.rules.length == 0);
const selectedOptions = ref<FormOption[]>(props.modelValue as FormOption[]);

watch(props, (newProps) => selectedOptions.value = newProps.modelValue)

const popperOptions: Partial<import("@popperjs/core").Options> = {
  modifiers: [
    {
      name: "sameWidth",
      enabled: true,
      fn: ({state}) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
      },
      phase: "beforeWrite",
      requires: ["computeStyles"],
      effect: ({state}) => {
        state.elements.popper.style.width = `${state.elements.reference.clientWidth}px`;
      },
    },
  ],
}

function toggleOption(option: FormOption) {
  let options = selectedOptions.value && selectedOptions.value.find(o => o.name == option.name)
    ? selectedOptions.value.filter(o => o.name != option.name)
    : [...selectedOptions.value, option];
  if (props.maxItems && options.length > props.maxItems)
    return;

  selectedOptions.value = options as FormOption[];
  emit("onOptionChange", options);

  validateInput();
}

function validateInput() {
  let validationRules = props.rules ? props.rules : [requiredArray]
  status.value = validateArray(selectedOptions.value, validationRules)

  emit("validated", props.name, status.value);
}

return (_ctx: any,_cache: any) => {
  const _component_tippy = _resolveComponent("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ error: !status.value.valid }, "form__field form-select-multiple"])
  }, [
    _createVNode(_component_tippy, {
      arrow: false,
      "popper-options": popperOptions,
      interactive: "",
      "max-width": "100%",
      offset: "0",
      theme: "custom-form-select",
      trigger: "click focus"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
            return (_openBlock(), _createElementBlock("span", {
              key: `fake__${option.name}`,
              class: "form-select-multiple__selection-option",
              onClick: ($event: any) => (toggleOption(option))
            }, _toDisplayString(option.label), 9, _hoisted_2))
          }), 128))
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.options)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: option.name,
                  class: _normalizeClass([{ 'selected': selectedOptions.value && selectedOptions.value.find(o => o.name == option.name) }, "form-select-multiple__option"]),
                  onClick: ($event: any) => (toggleOption(option))
                }, _toDisplayString(option.label), 11, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.noLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.name
        }, [
          _createTextVNode(_toDisplayString(_ctx.label ? _ctx.label : _ctx.name) + " ", 1),
          isRequired
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_5))
      : _createCommentVNode("", true),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          id: `error__${_ctx.name}`,
          class: "form__error-message"
        }, _toDisplayString(_unref(t)('validation.select')), 9, _hoisted_7))
      : _createCommentVNode("", true)
  ], 2))
}
}

})